import {
  Bell,
  LayoutDashboard,
  LifeBuoy,
  Menu,
  Ratio,
  Settings,
  SquareKanban,
  Wallet,
} from "lucide-react";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import AppNavMenu from "../menu/AppNavMenu";
import Sidebar, { SidebarItem } from "../sidebar/SidebarTwo";
import { SidebarSubItem } from "../sidebar/SidebarTwo";
import { isAuth } from "../../util";

const AppNavbar = ({ open, setOpen }) => {
  const menuRef = useRef();
  const user = useSelector((state) => state.user.userInfo);
  const userPermissions = useSelector((state) => state.user.permissions);
  const color = useSelector((state) => state.user.color);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="sm:sticky fixed left-0 top-0 right-0 bg-content shadow-lg shadow-bkg2/30 flex justify-between items-center px-4 py-2  z-20">
      <div className="bg-content ">
        {open && (
          <div
            ref={menuRef}
            className="h-dvh sm:hidden absolute  top-0 left-0 overflow-auto bg-content border-r border-bkg2/60 "
          >
            <Sidebar setOpen={setOpen} expand={true}>
              <SidebarItem
                onClick={handleClick}
                type="link"
                to="/dashboard"
                icon={<LayoutDashboard size={20} />}
                text="Dashboard"
              />
              {/* Manage Projects */}
              {isAuth(userPermissions, "projects", "read") && (
                <SidebarItem
                  type="container"
                  to="/reports"
                  onClick={handleClick}
                  icon={<SquareKanban size={20} />}
                  text="Council"
                  children={[
                    isAuth(userPermissions, "community_council", "read") && (
                      <SidebarSubItem
                        key={0}
                        text="Community Council"
                        to="/requests/community-approvals"
                      />
                    ),
                    isAuth(userPermissions, "community_council", "read") && (
                      <SidebarSubItem
                        key={1}
                        text="Community Reports"
                        to="/projects/community/reports"
                      />
                    ),
                    isAuth(userPermissions, "pdo_department", "read") && (
                      <SidebarSubItem
                        key={2}
                        text="PDO Dept"
                        to="/requests/pdo-approvals"
                      />
                    ),
                    isAuth(userPermissions, "pdo_department", "read") && (
                      <SidebarSubItem
                        key={3}
                        text="PDO Reports"
                        to="/projects/pdo/reports"
                      />
                    ),
                    isAuth(userPermissions, "provincial_council", "read") && (
                      <SidebarSubItem
                        key={4}
                        text="Provincial Council"
                        to="/requests/provincial-approvals"
                      />
                    ),
                    isAuth(userPermissions, "provincial_council", "read") && (
                      <SidebarSubItem
                        key={5}
                        text="Provincial Reports"
                        to="/projects/provincial/reports"
                      />
                    ),
                    isAuth(userPermissions, "accounts", "read") && (
                      <SidebarSubItem
                        key={6}
                        text="Accounts"
                        to="/projects/accounts"
                      />
                    ),
                    isAuth(userPermissions, "economer", "read") && (
                      <SidebarSubItem
                        key={7}
                        text="Economer "
                        to="/requests/economer-approvals"
                      />
                    ),
                    isAuth(userPermissions, "manage_projects", "read") && (
                      <SidebarSubItem
                        key={8}
                        text="Manage"
                        to="/projects/manage"
                      />
                    ),
                  ]}
                />
              )}
              {/* Projects */}
              <SidebarItem
                onClick={handleClick}
                type="container"
                to="/projects"
                icon={<Ratio size={20} />}
                alert
                text="Projects"
                children={[
                  isAuth(userPermissions, "projects", "read") && (
                    <SidebarSubItem
                      key={0}
                      text="My Initatives"
                      to="/requests/my-requests"
                    />
                  ),
                  isAuth(userPermissions, "pdo_department", "read") && (
                    <SidebarSubItem
                      key={1}
                      text="Proposals"
                      to="/projects/proposals"
                    />
                  ),
                  isAuth(userPermissions, "reformulation", "read") && (
                    <SidebarSubItem
                      key={2}
                      text="Mails"
                      to="/projects/reformulations"
                    />
                  ),
                  isAuth(userPermissions, "implementation", "read") && (
                    <SidebarSubItem
                      key={3}
                      text="Implementation"
                      to="/projects/implementations"
                    />
                  ),
                  isAuth(userPermissions, "evaluation", "read") && (
                    <SidebarSubItem
                      key={4}
                      text="Evaluation"
                      to="/projects/evaluations"
                    />
                  ),

                  isAuth(userPermissions, "projects", "read") && (
                    <SidebarSubItem
                      key={5}
                      text="Canceled"
                      to="/projects/canceled-projects"
                    />
                  ),
                  isAuth(userPermissions, "project_reports", "read") && (
                    <SidebarSubItem
                      key={6}
                      text="Project Reports"
                      to="/project-reports"
                    />
                  ),
                ]}
              />

              {isAuth(userPermissions, "accounts", "read") && (
                <SidebarItem
                  onClick={handleClick}
                  type="container"
                  to="/accounts"
                  icon={<Wallet size={20} />}
                  text="Fund MGR"
                  children={[
                    isAuth(userPermissions, "accounts", "read") && (
                      <SidebarSubItem
                        key={1}
                        text="Settings"
                        to="/accounts/maintenance"
                      />
                    ),
                    isAuth(userPermissions, "accounts", "read") && (
                      <SidebarSubItem
                        key={1}
                        text="Transactions"
                        to="/accounts/transaction"
                      />
                    ),
                    isAuth(userPermissions, "accounts", "read") && (
                      <SidebarSubItem
                        key={1}
                        text="Report"
                        to="/accounts/report"
                      />
                    ),
                  ]}
                />
              )}
              <SidebarItem
                onClick={handleClick}
                type="container"
                to="/settings"
                icon={<Settings size={20} />}
                text="Settings"
                children={[
                  isAuth(userPermissions, "countries", "read") && (
                    <SidebarSubItem
                      key={1}
                      text="Countries"
                      to="/settings/nations"
                    />
                  ),

                  isAuth(userPermissions, "communities", "read") && (
                    <SidebarSubItem
                      key={2}
                      text="Communities"
                      to="/communities"
                    />
                  ),
                  isAuth(userPermissions, "users", "read") && (
                    <SidebarSubItem key={3} text="Users" to="/users" />
                  ),
                  isAuth(userPermissions, "roles", "read") && (
                    <SidebarSubItem key={4} text="Roles" to="/settings/roles" />
                  ),
                  isAuth(userPermissions, "donors", "read") && (
                    <SidebarSubItem
                      key={5}
                      text="Donors"
                      to="/settings/donors"
                    />
                  ),
                  isAuth(userPermissions, "chart", "read") && (
                    <SidebarSubItem key={6} text="Chart" to="/settings/chart" />
                  ),
                  isAuth(userPermissions, "countries", "read") && (
                    <SidebarSubItem
                      key={7}
                      text="Nation"
                      to="/settings/nations"
                    />
                  ),
                  isAuth(userPermissions, "settings", "read") && (
                    <SidebarSubItem key={6} text="Settings" to="/settings" />
                  ),
                ]}
              />

              <SidebarItem
                onClick={handleClick}
                type="link"
                to="/help"
                icon={<LifeBuoy size={20} />}
                text="Help"
              />
            </Sidebar>
          </div>
        )}
        <button
          className="sm:hidden p-1.5 m-auto inline-block rounded-lg bg-gra-50 text-text-1 hover:bg-bkg"
          onClick={() => setOpen(true)}
        >
          <Menu size={31} />
        </button>
      </div>
      {/* Left Navigation */}
      <nav className="flex items-center gap-3 text-text-1">
        {/* <ThemeToggle /> */}
        <Bell size={35} className="nav-icon" />
        <Settings size={35} className="nav-icon" />
        <AppNavMenu user={user} color={color} setOpens={setOpen}></AppNavMenu>
      </nav>
    </header>
  );
};

export default AppNavbar;
